<template>
<div class="layout-topbar">
  <div class="left-panel">
    <Breadcrumb />
  </div>
  <div class="right-panel">
    <Userbar />
  </div>
</div>
</template>

<script>
import Breadcrumb from './Breadcrumb.vue';
import Userbar from './Userbar.vue';

export default {
  components: {
    Breadcrumb,
    Userbar
  }
}
</script>

<style lang="scss" scoped>
.layout-topbar {
  display: flex;
  padding-left: 10px;
  height: 50px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  justify-content:space-between;
  .left-panel {
    display: flex;
    align-items: center;
  }
  .right-panel {
    display: flex;
    align-items: center;
  }
}
</style>